import { render, staticRenderFns } from "./ListEmailTemplates.vue?vue&type=template&id=15615632&scoped=true&"
import script from "./ListEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./ListEmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ListEmailTemplates.vue?vue&type=style&index=0&id=15615632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15615632",
  null
  
)

export default component.exports